<template>
  <div class="topF" :class="{shou:Toptype === 1}">
    <div class="topFN">
      <div class="topImg">
        <a href="index.html"><img src="~@/assets/img/logo.png"></a>
      </div>
      <ul class="topUl">
        <li v-for="(item, index) in nav" :key="index" :class="{active:navN==index}">
          <div @click="jump(index)"><span class="line">{{item.name}}</span></div>
          <ul class="topUUl" v-if="item.show">
            <li class="topUUli" v-for="(i,index) in item.list" :key="index" :class="{active:0==index}" @click="jumpJ(i.url)">{{i.name}}
            </li>
          </ul>
        </li>
      </ul>
      <div class="hotline">业务热线：<br>400-805-0105</div>
      <div class="dataCoreD" v-if="isDataCore" @click="isDataCore = false">
        <div class="dataCoreDD">
          <div class="top">
            <div class="title">无权限</div>
            <div class="iconfont icon-untitled94"></div>
          </div>
          <div class="concent">
            <p>对不起，您暂无权限访问此页，如需开通权限，请联系管理员开通</p>
            <div class="button" @click="isDataCore = false">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Top',
  props: {
    navN: Number,
    Toptype: Number
  },
  data () {
    return {
      nav: [],
      isDataCore: false
    }
  },
  mounted () {
    this.getNav()
  },
  methods: {
    getNav () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getNav', {
      }).then(
        function (res) {
          res = res.data.data
          for (let i = 0; i<res.length; i++) {
            res[i].show = false
          }
          that.nav = res
        }
      ).catch(error => console.log(error))
    },
    jumpJ (url) {
      if (url == null) {
      } else {
        window.open(url + '?type=1')
      }
    },
    jump (index) {
      let nav = this.nav
      if (nav[index].list === undefined) {
        // location.href = this.nav[index].url + '?type=1'
        if (nav[index].name == '数据中心') {
          this.isDataCore = true
        } else {
          window.open(this.nav[index].url + '?type=1')
        }
      } else {
        for (let i = 0; i < nav.length; i++) {
          if (i !== index) {
            this.nav[i].show = false
          }
        }
        nav[index].show = !nav[index].show
      }
      this.nav = nav
    }
  }
}
</script>
<style lang="stylus" scoped>
.topF
  width 100%
  height .98rem
  position fixed
  top 0
  left 0
  z-index 99
  background #fff
  .topFN
    max-width 1200px
    min-width 700px
    width 90%
    display flex
    margin 0 auto
    height .98rem
    justify-content space-between
    align-content center
    .topImg
      display flex
      padding .28rem 0
      img
        height .44rem
      div
        margin-top .2rem
        p
          font-size .15rem
          font-style italic
          color var(--indexColor)
          margin-left .2rem
          height .2rem
          line-height .25rem
    .topUl
      display flex
      margin-left 5%
      li
        width 1rem
        line-height .68rem
        color #666666
        font-size .16rem
        position relative
        text-align center
        margin-top .2rem
        .topUUl
          position absolute
          top .78rem
          left 0px
          width 100%
          background #020202
          box-shadow 0px 5px 10px 0px #151515
          li
            width 100%
            height .4rem
            line-height .4rem
            font-size .14rem
            margin-top 0
            color #fff
          li.active
            background var(--indexColor)
            color #fff
            border-bottom 0px
          li:first-child
            border-top-left-radius .03rem
            border-top-right-radius .03rem
          li:last-child
            border-bottom-left-radius .03rem
            border-bottom-right-radius .03rem
            a
              border-bottom 0px
      li.active
        color var(--indexColor)
        .line
          width 100%
          display inline
          height 1px solid var(--indexthemeColor)
    .topLog
      display flex
      .register
        height .68rem
        line-height .68rem
        padding 0 .2rem
        margin-top .2rem
        a
          font-size .18rem
          color #fff
    .hotline
      font-size .2rem
      color #C91820
      padding-top .27rem
  .dataCoreD
    width 100%
    height 100%
    position fixed
    top 0%
    left 0%
    z-index -1
    .dataCoreDD
      width 6.81rem
      position absolute
      top 50%
      left 50%
      transform translate(-50%,-50%)
      box-shadow 0px 6px 12px rgba(0, 0, 0, 0.16)
      .top
        width 100%
        height .73rem
        line-height .73rem
        display flex
        justify-content space-between
        background linear-gradient(267deg, #207FE4 0%, #4CB4EF 100%)
        padding 0 .18rem
        .title
          font-size .3rem
        .iconfont
          width .16rem
          color #fff
      .concent
        width 100%
        background #fff
        padding .38rem .18rem
        p
          font-size .24rem
          color #1F1E1E
          span
            color #0C66DF
        .button
          width 1.8rem
          height .6rem
          line-height .6rem
          color #fff
          background linear-gradient(267deg, #207FE4 0%, #4CB4EF 100%)
          font-size .36rem
          text-align center
          margin 0 auto
          margin-top 1rem
.shou
  top 0rem
  background #FFFFFF
  box-shadow: 0px 0px 36px 0px rgba(9, 9, 9, 0.19)
</style>



// WEBPACK FOOTER //
// src/components/Top.vue